import { type ReactNode } from "react";
import { Typography } from "antd";

interface DetailLinkProps {
  children: ReactNode;
  title?: string;
  onClick: () => void;
}

export function DetailLink({ children, title, onClick }: DetailLinkProps) {
  return (
    <Typography.Link
      title={title ?? "点击查看详情"}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      style={{ wordBreak: "break-all" }}
    >
      {children}
    </Typography.Link>
  );
}
